import Model from "../../core/model/Model";
import ValidatableObject from "../../core/model/validation/ValidatableObject";

export interface TCourtCaseConnectionType {
  id: number;
  name: string;
  valid: boolean;
}

export interface ICourtCaseConnectionType extends TCourtCaseConnectionType {}

const CourtCaseConnectionType = Model(
  (model: TCourtCaseConnectionType): ICourtCaseConnectionType => {
    const _value: TCourtCaseConnectionType = Object.assign({}, model);

    let _model = {
      get id() {
        return _value.id;
      },
      set id(value) {
        _value.id = value;
      },
      get name() {
        return _value.name;
      },
      set name(value) {
        _value.name = value;
      },
      get valid() {
        return _value.valid;
      },
      set valid(value) {
        _value.valid = value;
      }
    };

    return ValidatableObject<ICourtCaseConnectionType>(_model);
  }
);

export default CourtCaseConnectionType;
